module.exports = __webpack_public_path__ + "static/media/07.017a546a.wav";